// Libs
import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import isEmpty from "lodash/isEmpty";

// Components
import "@collectivehealth/dls-icons/dist/es/elements/dls-icon-arrow-left-large.js";
import IconButton from "components/buttons/IconButton";
import MenuLink from "components/sidebar/MenuLink";

// Contexts
import FeatureSwitchContext from "contexts/FeatureSwitch";

// Styles
import styles from "./SubMenu.css";

// Constants
import { PATHS } from "constants/routing";
export const DATA_HOOK = "SubMenu";

function SubMenu({
  closeSubMenu,
  isDisplayed = false,
  subMenuItems = [],
  title = "",
  subtitle,
  defaultFocus
}) {
  // Import feature flag for showing/hiding Program Partners submenu item
  const { features } = React.useContext(FeatureSwitchContext);

  /**
   * Determines whether to show/hide Program Partners submenu item based on feature flag
   * @param {*object} features features.showProgramPartnersFeature will either be true (boolean) or ["false"] (array with string)
   * @returns {*boolean}
   */
  function shouldShowProgramPartners(features) {
    if (features && features.showProgramPartnersFeature) {
      return features.showProgramPartnersFeature === true;
    }
    return false;
  }

  for (const item of subMenuItems) {
    if (item.path === PATHS.CLAIMS_PARTNERS && !shouldShowProgramPartners(features)) {
      item.hidden = true;
    }
  }

  return (
    <div
      className={classnames(styles.root, {
        [styles.hidden]: !isDisplayed
      })}
      data-hook={DATA_HOOK}
      aria-hidden={isDisplayed ? false : true}
    >
      {/* Collapse SubMenu Button*/}
      <IconButton
        className={styles.collapse}
        onClick={() => closeSubMenu(defaultFocus)}
        tabIndex={isDisplayed ? 0 : -1}
      >
        <dls-icon-arrow-left-large />
      </IconButton>

      {/* SubMenu Title */}
      {!isEmpty(title) && <div className={styles.title}>{subtitle ? subtitle : title}</div>}

      {/* SubMenu Items */}
      {subMenuItems.map(({ path, basePath = null, search, title, persistQueryParams, hidden }) => {
        return (
          !hidden && (
            <MenuLink
              hasSubMenu={false}
              isSubMenuLink={true}
              key={path}
              path={path}
              basePath={basePath}
              persistQueryParams={persistQueryParams}
              search={search}
              title={title}
            />
          )
        );
      })}
    </div>
  );
}

SubMenu.propTypes = {
  closeSubMenu: PropTypes.func.isRequired,
  isDisplayed: PropTypes.bool,
  subMenuItems: PropTypes.array,
  title: PropTypes.string
};

export default SubMenu;
